import { render } from "./language_component.vue?vue&type=template&id=84b0af3c&scoped=true"
import script from "./language_component.vue?vue&type=script&lang=js"
export * from "./language_component.vue?vue&type=script&lang=js"

import "./language_component.vue?vue&type=style&index=0&id=84b0af3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b0af3c"]])

export default __exports__